import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "paymentBrick_container" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { loadMercadoPago } from "@mercadopago/sdk-js";
  import { onMounted, onBeforeUnmount } from "vue";

  declare global {
    interface Window {
      MercadoPago: any;
      paymentBrickController: any;
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MercadoPagoComponent',
  setup(__props) {

  /* eslint-disable */ 
  onBeforeUnmount(() => {
    if (window.paymentBrickController) {
      window.paymentBrickController.unmount();
    } else {
      console.error("paymentBrickController not found");
    }
  })

  onMounted( async () => {
    await loadMercadoPago();
    const mp = new window.MercadoPago("TEST-aa08c433-8dfb-4dec-a712-829af46bc226", {
      locale: "es",
    });
    const bricksBuilder = mp.bricks();
    const renderPaymentBrick = async (bricksBuilder : any) : Promise<void> => {
      const settings = {
        initialization: {
          /*
          "amount" es el monto total a pagar por todos los medios de pago con excepción de la Cuenta de Mercado Pago y Cuotas sin tarjeta de crédito, las cuales tienen su valor de procesamiento determinado en el backend a través del "preferenceId"
          */
          amount: 10000,
          preferenceId: "<PREFERENCE_ID>",
            payer: {
              firstName: "",
              lastName: "",
              email: "",
            },
          },
          customization: {
            visual: {
              style: {
                theme: "default",
              },
            },
            paymentMethods: {
              creditCard: "all",
              debitCard: "all",
              ticket: "all",
              bankTransfer: "all",
              atm: "all",
              onboarding_credits: "all",
              wallet_purchase: "all",
              maxInstallments: 1
            },
          },
          callbacks: {
            onReady: () => {
              /*
              Callback llamado cuando el Brick está listo.
              Aquí puede ocultar cargamentos de su sitio, por ejemplo.
              */
            },
            onSubmit: ({ selectedPaymentMethod, formData }: { selectedPaymentMethod: string, formData: any }) => {
              // callback llamado al hacer clic en el botón de envío de datos
              return new Promise((resolve, reject) => {
                fetch("/process_payment", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(formData),
                })
                .then((response) => response.json())
                .then((response) => {
                  // recibir el resultado del pago
                  resolve( response );
                })
                .catch((error) => {
                  // manejar la respuesta de error al intentar crear el pago
                  reject();
                });
              });
            },
            onError: (error : any) => {
              // callback llamado para todos los casos de error de Brick
              console.error(error);
            },
          },
        };
        window.paymentBrickController = await bricksBuilder.create(
        "payment",
        "paymentBrick_container",
        settings
        );
      };
      renderPaymentBrick(bricksBuilder);
      
    });

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}
}

})